module.exports = __webpack_public_path__ + "static/media/facebook-btn.ee1b19d2.svg";